import React, { useEffect, useState, useLayoutEffect } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
  Paper,
  Divider,
  TextField,
  Slider,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { connect, useSelector } from "react-redux";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
import { ReactComponent as Info } from "Assets/Icons/info.svg";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import {
  START_UPDATE_GLOBAL_SETTING,
  START_GLOBAL_SETTING,
} from "Actions/RepeatOrderAction";
import useViewport from "Hooks/useViewport";
import {
  START_GET_COLLECTION_LIST,
  START_GET_COLLECTION_COUNT,
} from "Actions/CollectionAction";
import AccessDialog from "./AccessDialog";
import { getLocalStorage } from "utils/generalUtils";
import { ReactComponent as ActivityLog } from "Assets/Icons/ActivityLogs.svg";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { useNavigate } from "react-router-dom";
import SubscriptionWaringDailog from "Components/Common/Dialog/SubscriptionWaringDailog";
import { MaximizeSharp } from "@mui/icons-material";
const useStyle = makeStyles((theme) => ({
  rsSetting: {
    padding: "17px 13px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    "&>h3": {
      // fontSize: "20px !important",
      marginBottom: "16px",
    },
    "&>div": {
      "&>hr": {
        // marginBottom: "30px",
        background: `${theme.palette.background.grey} !important`,
      },
    },

    // [theme.breakpoints.down("1300")]: {
    //   height: "600px !important",
    //   "&>div": {
    //     display: "inline !important",
    //   },
    // },
    // [theme.breakpoints.down("607")]: {
    //   height: "702px !important",
    // },
    // [theme.breakpoints.down("517")]: {
    //   height: "682px !important",
    // },
    // [theme.breakpoints.down("500")]: {
    //   height: "701px !important",
    // },
  },
  rsDriverSetting: {
    padding: "17px 13px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    // height: "730px !important",
    // height: "746px !important",
    height: "auto",
    backgroundColor: theme.palette.background.default,
    "&>h3": {
      // fontSize: "20px !important",
      marginBottom: "16px",
    },
    "&>div": {
      "&>hr": {
        // marginBottom: "30px",
        background: `${theme.palette.background.grey} !important`,
      },
    },
    // [theme.breakpoints.down("1300")]: {
    //   height: "750px !important",
    //   "&>div": {
    //     display: "inline !important",
    //   },
    // },
    // [theme.breakpoints.down("720")]: {
    //   height: "780px !important",
    // },
    // [theme.breakpoints.down("517")]: {
    //   height: "682px !important",
    // },
    // [theme.breakpoints.down("500")]: {
    //   height: "701px !important",
    // },
  },
  titleBtn: {
    display: "flex",
    justifyContent: "space-between",
    "&>h3": {
      // fontSize: "20px !important",
      marginBottom: "16px",
    },
  },
  infoIcon: {
    marginLeft: "3px",
    marginBottom: "-9px",
    width: "20px",
    cursor: "pointer",
  },
  rsSettingSaveBtn: {
    // marginRight: "60px !important",
    // fontSize: "14px !important",
    fontWeight: "400 !important",
    borderRadius: "5px !important",
    marginTop: "30px !important",
    width: "142px!important",
  },
  rsTooltip: {
    left: "100px !important",
  },
  rsDlabelWhiteSpaceNW: {
    display: "flex",
  },
  rsNolabel: {
    display: "flex !important",
    "&:nth-child(2)": {
      marginLeft: "30px !important",
    },
    "&>span:nth-child(2)": {
      color: "black !important",
    },
  },
  rsDSettingSaveBtn: {
    // marginRight: "60px !important",
    // fontSize: "14px !important",
    fontWeight: "400 !important",
    borderRadius: "5px !important",
    marginTop: "10px !important",
    width: "142px!important",
  },
  rsOSetting: {
    padding: "17px 13px",
    height: "713px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    "&>h3": {
      // fontSize: "20px !important",
      marginBottom: "16px",
    },
    "&>hr": {
      marginBottom: "30px",
      background: `${theme.palette.background.grey} !important`,
    },
    "&>div": {
      display: "inline !important",
    },
    [theme.breakpoints.down("500")]: {
      height: "730px !important",
    },
  },
  rsDSetting: {
    padding: "17px 13px",
    height: "813px !important",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    "&>h3": {
      // fontSize: "20px !important",
      // marginBottom: "16px",
    },
    "&>hr": {
      marginBottom: "30px",
      background: `${theme.palette.background.grey} !important`,
    },
    "&>div": {
      display: "inline !important",
    },
    [theme.breakpoints.down("520")]: {
      height: "880px !important",
    },
    [theme.breakpoints.down("460")]: {
      height: "930px !important",
    },
    [theme.breakpoints.down("370")]: {
      height: "1000px !important",
    },
  },
  rsDsubmit: {
    textAlign: "center !important",
    display: "block !important",
  },
  rssubmit: {
    textAlign: "center !important",
    display: "block !important",
    marginTop: "10px !important",
    marginBottom: "10px !important",
  },
  rsDisablecolor: {
    "&:disabled": {
      color: "red !important",
    },
  },
  labelWhiteSpaceNW: {
    marginLeft: "3px !important",
    [theme.breakpoints.down("460")]: {
      marginLeft: "-11px !important",
    },
    "&:nth-child(1)": {
      marginLeft: "-11px !important",
    },
    "&>span:nth-child(2)": {
      color: "#262626 !important",
      // fontSize: "18px !important",
      fontWeight: "400 !important",
      fontFamily: "Poppins !important",
    },
    "& .Mui-disabled": {
      color: "#5A6872 !important",
      fontWeight: "bold",
    },
  },
  rsSettingnote: {
    "&>h5": {
      color: "rgb(233, 81, 78)",
      marginTop: "-20px",
      marginBottom: "10px",
    },
  },
  rsOrderDate: {
    paddingTop: "5px",
    paddingBottom: "10px",
    color: "#5A6872",
    // fontSize: "14px",
  },
  rsPharmacyMain: {
    paddingTop: "10px",
  },
  rsTextField: {
    marginBottom: "13px !important",
    "& .MuiFormHelperText-root.Mui-error": {
      marginBottom: "-12px",
    },
  },
  btnstyle: {
    [theme.breakpoints.down("391")]: {
      //display: "flex",
      paddingBottom: "2em",
      marginLeft: "-150px",
      paddingTop: "1em",
    },
    [theme.breakpoints.down("361")]: {
      //display: "flex",
      paddingBottom: "2em",
      marginLeft: "-130px",
      paddingTop: "1em",
    },
  },
  btngap: {
    [theme.breakpoints.down("391")]: {
      gap: "92px !important",
      marginBottom: "10px !important",
    },
    [theme.breakpoints.down("361")]: {
      gap: "76px !important",
      marginBottom: "10px !important",
    },
  },
  activityBtn: {
    marginLeft: "5px !important",
    marginRight: "5px !important",
    "&>span": {
      "&>svg": {
        "&>g": {
          "&>path": {
            fill: `white !important`,
          },
        },
      },
    },

    [theme.breakpoints.down("405")]: {
      width: "200px",
      marginRight: "0px !important",
    },
    [theme.breakpoints.down("376")]: {
      marginBottom: "10px !important",
    },
  },
  rsslider: {
    width: "500px !important",
    marginTop: "42px",
    marginBottom: "30px !important",
    marginLeft: "9px",
    [theme.breakpoints.between("880", "900")]: {
      width: "calc(53vw + 10px) !important",
    },
    [theme.breakpoints.between("768", "850")]: {
      width: "calc(50vw + 10px) !important",
    },
    [theme.breakpoints.down("600")]: {
      width: "calc(88vw + 10px) !important",
    },
    [theme.breakpoints.between("450", "520")]: {
      width: "calc(85vw + 10px) !important",
    },
    [theme.breakpoints.between("200", "450")]: {
      width: "calc(82vw + 10px) !important",
    },
    [theme.breakpoints.down("900")]: {
      "&>span:nth-child(6)": {
        left: "90% !important",
      },
    },
    [theme.breakpoints.down("420")]: {
      "&>span:nth-child(6)": {
        left: "80% !important",
      },
    },
  },
  rsMainMarign: {
    marginTop: "20px !important",
    height: "100% !important",
    overflowY: "auto",
    [theme.breakpoints.down(768)]: {
      marginTop: "30px !important",
    },
  },
  greenDivider: {
    background: "#7BC044 !important",
    height: "2px",
  },
  fixedGrid: {
    position: "sticky",
    top: "0px",
  },
  subContainer: {
    maxHeight: "calc(54vh + 100px) !important",
    // maxHeight:"calc(61vh + 100px) !important",
    overflowY: "auto",
    "@media (max-height: 920px)": {
      height: "calc(52vh + 100px) !important",
    },
    "@media (max-height: 880px)": {
      height: "calc(48vh + 100px) !important",
    },
    "@media (max-height: 850px)": {
      height: "calc(48vh + 100px) !important",
    },
    "@media (max-height: 800px)": {
      height: "calc(45vh + 100px) !important",
    },
    "@media (max-height: 785px)": {
      height: "calc(40vh + 100px) !important",
    },
    "@media (max-height: 700px)": {
      height: "calc(35vh + 100px) !important",
    },
    "&>div": {
      "&>h3": {
        fontSize: "1.2rem  !important",
        fontWeight: "600 !important",
        color: "#404040  !important",
        marginTop: "10px",
        marginBottom: "0px !important",
      },
      "&>h5": {
        fontSize: "1.1rem  !important",
        fontSize: "16px  !important",
        fontWeight: "400 !important",
        color: "#262626 !important",
      },
      "&>h6": {
        fontSize: "0.9rem  !important",
        // fontSize: "16px !important",
        fontWeight: "400 !important",
        color: "rgba(80, 80, 80, 0.6) !important",
      },
    },
  },
  subContainerDriver: {
    maxHeight: "calc(51vh + 100px) !important",
    overflowY: "auto",
    "@media (max-height: 850px)": {
      height: "calc(48vh + 100px) !important",
    },
    "@media (max-height: 800px)": {
      height: "calc(45vh + 100px) !important",
    },
    "@media (max-height: 785px)": {
      height: "calc(40vh + 100px) !important",
    },
    "@media (max-height: 700px)": {
      height: "calc(35vh + 100px) !important",
    },
    "&>div": {
      "&>h3": {
        fontSize: "1.2rem  !important",
        fontWeight: "600 !important",
        color: "#404040  !important",
        marginTop: "10px",
        marginBottom: "0px !important",
      },
      "&>h5": {
        fontSize: "1.1rem  !important",
        fontSize: "16px  !important",
        fontWeight: "400 !important",
        color: "#262626 !important",
      },
      "&>h6": {
        fontSize: "0.9rem  !important",
        // fontSize: "16px !important",
        fontWeight: "400 !important",
        color: "rgba(80, 80, 80, 0.6) !important",
      },
    },
    "&>h3": {
      fontSize: "1.2rem  !important",
      fontWeight: "600 !important",
      color: "#404040  !important",
      marginTop: "20px",
      marginBottom: "0px !important",
    },
  },
  driverFilter: {
    [theme.breakpoints.down("1000")]: {
      marginLeft: "-11px !important",
    },
  },
}));

const GlobalSettingMain = (props) => {
  const classes = useStyle();
  let dummyObj = { data: { repeatOrderSetting: { gs_value: 7 } } };
  const { width } = useViewport();
  const {
    globalSetting = dummyObj,
    updateGlobalSettingAction,
    getGlobalSettingAction,
    getCollectionRxAction,
    getCollectionCountAction,
  } = props;
  const [orderGap, setOrderGap] = useState("7");
  const OrderGapList = [28, 21, 14, 10, 7];
  const [chaseUp, setChaseUp] = useState(3);
  const chaseUpList = [2, 3, 4, 5];
  const [archive, setArchive] = useState(28);
  const [archiveID, setArchiveID] = useState("");
  const [orderID, setOrderID] = useState("");
  const [chaseUpID, setChaseupID] = useState("");
  const [driverFilterID, setDriverFilterID] = useState("");
  const [ccID, setCCId] = useState("");
  const [accessopen, setAccessopen] = useState(false);
  const archiveList = [10, 14, 21, 28];
  const [ccMain, setCCMain] = useState("Yes");
  const [ccEmail, setCCEmail] = useState("");
  const [ccErrorhadle, setCCErrorhadle] = useState({
    type: false,
    message: "",
  });

  const valideEMails = ["nhs.net", "nhs.scot", "wales.nhs.uk", "hscni.net" , "health.gg" , "healthcare.gg" , 'eqrmp.com' , 'channelislands.coop' ];
  const ccList = ["Yes", "No"];
  const [orderItem, setOrderItem] = useState(24);
  const emailPharmacy = getLocalStorage("pharmacyEmail");
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const marks = [
    {
      value: 3,
      label: "3 Days",
    },
    {
      value: 28,
      label: "28 Days",
    },
  ];

  const afterOrderDateItems = [
    { index: 0, label: "All prescriptions", value: 0 },
    { index: 1, label: "+24 hours", value: 24 },
    { index: 2, label: "+48 hours", value: 48 },
    { index: 3, label: "+72 hours", value: 72 },
  ];

  const { loginUserDetail } = useSelector((state) => state.user);
  const navigate = useNavigate();
  /** list call  */
  useEffect(() => {
    setOrderGap(
      parseInt(
        globalSetting?.data?.repeatOrderSetting?.gs_value
          ? globalSetting?.data?.repeatOrderSetting?.gs_value
          : "7"
      )
    );
    setOrderID(globalSetting?.data?.repeatOrderSetting?.gs_id);
  }, [globalSetting?.data?.repeatOrderSetting?.gs_value]);

  useEffect(() => {
    setChaseUp(parseInt(globalSetting?.data?.chaseUpSetting?.gs_value));
    setChaseupID(globalSetting?.data?.chaseUpSetting?.gs_id);
  }, [globalSetting?.data?.chaseUpSetting?.gs_value]);

  useEffect(() => {
    setArchive(parseInt(globalSetting?.data?.archiveDaysSetting?.gs_value));
    setArchiveID(globalSetting?.data?.archiveDaysSetting?.gs_id);
  }, [globalSetting?.data?.archiveDaysSetting?.gs_value]);

  useEffect(() => {
    setOrderItem(parseInt(globalSetting?.data?.DriverHoursSetting?.gs_value));
    setDriverFilterID(globalSetting?.data?.DriverHoursSetting?.gs_id);
  }, [globalSetting?.data?.DriverHoursSetting?.gs_value]);

  useEffect(() => {
    if (globalSetting?.data?.ccPharmacyEmailSetting?.gs_value) {
      setCCMain(
        globalSetting?.data?.ccPharmacyEmailSetting?.gs_value == 1
          ? "Yes"
          : "No"
      );
    }

    setCCId(globalSetting?.data?.ccPharmacyEmailSetting?.gs_id);
    setCCEmail(globalSetting?.data?.ccPharmacyEmailSetting?.gs_other_value);
    // cc_orders_to_pharmacy;
  }, [globalSetting?.data]);
  /** update setting action */
  const updateSettingAction = () => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    // if (loginUserDetail?.data?.data?.is_manage_settings === false) {
    //   if (
    //     loginUserDetail?.data?.data?.role === "pharmacist_staff" ||
    //     loginUserDetail?.data?.data?.role === "pharmacist" ||
    //     loginUserDetail?.data?.data?.role === "user"
    //   ) {
    //     setAccessopen(true);
    //   } else {
    //     setOrderGap(orderGap);
    //     let payload = {
    //       settings: [
    //         {
    //           gs_id: orderID,
    //           gs_short_code: "preferred_ordergap",
    //           gs_value: orderGap,
    //         },
    //         {
    //           gs_id: chaseUpID,
    //           gs_short_code: "chase_up",
    //           gs_value: chaseUp,
    //         },
    //         {
    //           gs_id: archiveID,
    //           gs_short_code: "archive_days",
    //           gs_value: archive,
    //         },
    //         {
    //           gs_id: driverFilterID,
    //           gs_short_code: "driver_hours",
    //           gs_value: orderItem,
    //         },
    //         {
    //           gs_id: driverFilterID,
    //           gs_short_code: "driver_hours",
    //           gs_value: orderItem,
    //         },
    //         {
    //           gs_id: ccID,
    //           gs_short_code: "cc_orders_to_pharmacy",
    //           gs_value: ccMain === "Yes" ? 1 : 0,
    //         },
    //       ],
    //     };
    //     updateGlobalSettingAction(payload, "repeatOrder");
    //   }
    // } else {
    if ((ccEmail == null || ccEmail == "") && ccMain == "Yes") {
      setCCErrorhadle({
        type: true,
        message: "Please enter cc email address",
      });
      return;
    } else if (ccErrorhadle?.type === true && ccMain === "Yes") {
      return;
    }
    setOrderGap(orderGap);
    let payload = {
      settings: [
        {
          gs_id: orderID,
          gs_short_code: "preferred_ordergap",
          gs_value: orderGap,
        },
        {
          gs_id: chaseUpID,
          gs_short_code: "chase_up",
          gs_value: chaseUp,
        },
        {
          gs_id: archiveID,
          gs_short_code: "archive_days",
          gs_value: archive,
        },
        {
          gs_id: driverFilterID,
          gs_short_code: "driver_hours",
          gs_value: orderItem,
        },
        {
          gs_id: ccID,
          gs_short_code: "cc_orders_to_pharmacy",
          gs_value: ccMain === "Yes" ? 1 : 0,
          gs_other_value: ccEmail,
        },
      ],
    };
    updateGlobalSettingAction(payload, "repeatOrder");
    // }
    // }
  };
  useEffect(() => {
    if (ccMain == "No") {
      setCCErrorhadle({
        type: false,
        message: "",
      });
      setCCEmail("");
    }
  }, [ccMain]);

  useEffect(() => {
    if (globalSetting?.success === true) {
      let payload = {
        offset: 0,
        type: "un_collected",
      };
      // getCollectionRxAction(payload);
      // getCollectionCountAction();
    }
  }, [globalSetting?.success]);
  useEffect(() => {
    getGlobalSettingAction();
  }, []);

  useEffect(() => {
    if (globalSetting?.data?.repeatOrderSetting?.preferred_ordergap?.gs_value) {
      getGlobalSettingAction();
    }
  }, [globalSetting?.data?.repeatOrderSetting?.preferred_ordergap?.gs_value]);

  const handleSliderChange = (event, newValue) => {
    setOrderGap(newValue);
  };

  const valueLabelFormat = (value) => {
    return `${value} Day${value > 1 ? "s" : ""}`;
  };

  const handleccEmailChange = (e) => {
    let value = e.target.value;
    const domain = value.split("@")[1];
    setCCEmail(e.target.value);
    let staging = process.env.REACT_APP_FOR_STAGEING;
    if (value === "") {
      setCCErrorhadle({ type: true, message: "Email is required" });
    } else if (!/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/.test(e.target.value)) {
      setCCErrorhadle({
        type: true,
        message: "Please enter valid email address",
      });
    } else if (!valideEMails.includes(domain) && staging !== "true") {
      setCCErrorhadle({
        type: true,
        message: (
          <>
            Please enter valid email address <br />
            Accepted domains: {
                valideEMails.map((item, index) => {
                  return (
                  <strong key={index}>
                    {item}
                    {index !== valideEMails.length - 1 ? "," : "."}
                  </strong>
                );
              })
            }
          </>
        ),
      });
    } else {
      setCCErrorhadle({ type: false, message: "" });
    }
  };

  return (
    <Grid className={classes.rsMainMarign}>
      <Grid
        container
        columnSpacing={2.5}
        rowSpacing={3}
        className={classes.rsPatientGridOne}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Paper
            elevation={0}
            className={
              loginUserDetail?.data?.data?.role === "user"
                ? classes.rsDriverSetting
                : classes.rsSetting
            }
            // style={{
            //   height:
            //     loginUserDetail?.data?.data?.role === "user"
            //       ? "820px"
            //       : "800px",
            // }}
          >
            <Box className={classes.fixedGrid}>
              <Box className="GlobalSettingHeading">
                <Typography variant="h3" medium color="secondary">
                  Settings
                </Typography>
              </Box>
              <Box
                className={clsx("GlobalSettingHeading", classes.btngap)}
                marginBottom={"10px"}
              >
                <Typography
                  variant="h4"
                  style={{
                    fontWeight: "600",
                  }}
                  color="black"
                >
                  Global
                </Typography>
                <Box className={classes.btnstyle}>
                  <Button
                    className={classes.activityBtn}
                    style={{ marginBottom: "10px" }}
                    variant="contained"
                    startIcon={
                      <PrimaryIcon
                        icon={ActivityLog}
                        color="white"
                        width="16px"
                        height="16px"
                      />
                    }
                    onClick={() => {
                      navigate(`/activity`);
                    }}
                  >
                    Activity Log
                  </Button>
                  {loginUserDetail?.data?.data?.is_applied_payment && (
                    <>
                      {loginUserDetail?.data?.data?.role === "pharmacy" && (
                        <Button
                          style={{ marginBottom: "10px" }}
                          className={classes.activityBtn}
                          variant="contained"
                          startIcon={
                            <PrimaryIcon
                              icon={CreditScoreIcon}
                              color="white"
                              width="16px"
                              height="16px"
                            />
                          }
                          onClick={() => {
                            navigate(`/payment-log`);
                          }}
                        >
                          Payment Log
                        </Button>
                      )}
                    </>
                  )}
                </Box>
              </Box>

              <Box
                style={{
                  width: "80px",
                  height: "2px",
                }}
              >
                <Divider className={classes.greenDivider} />
              </Box>
              <Divider />
            </Box>
            {/* CHASE UP */}

            <Grid
              className={
                loginUserDetail?.data?.data?.role === "user"
                  ? classes.subContainerDriver
                  : classes.subContainer
              }
            >
              <Grid item>
                <Typography
                  color="#404040"
                  regular
                  variant="h3"
                  // marginTop={"40px"}
                  // fontWeight={"600"}
                  // fontSize={"20px"}
                  marginTop={"20px"}
                  // marginTop={"5px"}
                  marginBottom={"8px"}
                >
                  Chase Up*
                  {/* <HtmlTooltipMain
                      title={`${"Choose how long you would like to wait until users start to chase up prescriptions. After e.g. 48 hours the chase up icon will appear on waiting list."}`}
                      className={classes.rsTooltip}
                    >
                      <Info className={classes.infoIcon} />
                    </HtmlTooltipMain> */}
                </Typography>
                <Typography
                  // color="black"
                  regular
                  variant="h5"
                  // fontWeight={"400"}
                  // fontSize={"18px !important"}
                >
                  Set the number of days after ordering for the chase up icon to
                  appear
                </Typography>
                <Typography
                  color="grey"
                  regular
                  variant="h6"
                  fontWeight={"400"}
                  fontSize={"14px !important"}
                >
                  Choose how long you would like to wait until users start to
                  chase up prescriptions. After e.g. 48 hours the chase up icon
                  will appear on waiting list.
                </Typography>

                <Grid display={"flex"} container>
                  {chaseUpList?.map((item, index) => {
                    return (
                      <FormControlLabel
                        className={classes.labelWhiteSpaceNW}
                        value={item}
                        key={index}
                        checked={chaseUp === item}
                        onChange={(e, value) => {
                          setChaseUp(item);
                        }}
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                            color="primary"
                          />
                        }
                        label={
                          item === 3
                            ? `${item} Days (Suggested)`
                            : `${item} Days`
                        }
                      />
                    );
                  })}
                </Grid>
              </Grid>

              {/* Preferred Ordergap * Archive */}
              <Grid>
                <Typography
                  color="#404040"
                  // color="secondary"
                  regular
                  variant="h3"
                  fontSize={"20px"}
                  fontWeight={"600"}
                  marginTop={"30px"}
                  marginBottom={"8px !important"}
                >
                  Archive*
                  {/* <HtmlTooltipMain
                    title={`${"Patient orders will automatically move from the uncollected list into the archived folder if not collected after this many days"}`}
                    className={classes.rsTooltip}
                  >
                    <Info className={classes.infoIcon} />
                  </HtmlTooltipMain> */}
                </Typography>

                <Typography
                  color="black"
                  regular
                  variant="h5"
                  fontWeight={"400"}
                  fontSize={"18px !important"}
                >
                  Waiting prescriptions will be automatically archived after a
                  certain number of days
                </Typography>
                <Typography
                  color="grey"
                  regular
                  variant="h6"
                  fontWeight={"400"}
                  fontSize={"14px !important"}
                >
                  Patient orders will automatically move from the uncollected
                  list into the archived folder if not collected after this many
                  days
                </Typography>

                <Grid display={"flex"} container>
                  {archiveList?.map((item, index) => {
                    return (
                      <FormControlLabel
                        className={classes.labelWhiteSpaceNW}
                        value={item}
                        key={index}
                        checked={archive === item}
                        onChange={(e, value) => {
                          setArchive(item);
                        }}
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                            color="primary"
                          />
                        }
                        label={
                          item === 21
                            ? `${item} Days (Suggested)`
                            : `${item} Days`
                        }
                      />
                    );
                  })}
                </Grid>
              </Grid>

              {/* CC email */}
              <Grid>
                <Typography
                  regular
                  variant="h3"
                  fontSize={"20px"}
                  fontWeight={"600"}
                  marginTop={"30px"}
                  marginBottom={"8px !important"}
                  color="#404040"
                >
                  {/* CC emailed order to pharmacy * */}
                  CC to pharmacy email*
                  {/* <HtmlTooltipMain
                    title={`${"Auto archive order if not collected in X days."}`}
                    className={classes.rsTooltip}
                  >
                    <Info className={classes.infoIcon} />
                  </HtmlTooltipMain>{" "} */}
                </Typography>
                <Typography
                  color="black"
                  regular
                  variant="h5"
                  fontWeight={"400"}
                  fontSize={"18px !important"}
                >
                  Would you like emails to surgeries to be emailed to the
                  pharmacy as well?
                </Typography>
                <Box display={"flex"} alignItems={"start"}>
                  {ccList?.map((item, index) => {
                    return (
                      <FormControlLabel
                        // className={classes.rsDlabelWhiteSpaceNW}
                        className={classes.rsNolabel}
                        value={item}
                        key={index}
                        checked={ccMain === item}
                        onChange={(e, value) => {
                          setCCMain(item);
                        }}
                        sx={{
                          marginTop: ccMain === "Yes" ? "8px" : "0px",
                        }}
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                            color="primary"
                          />
                        }
                        label={`${item}`}
                      />
                    );
                  })}
                  {ccMain == "Yes" && (
                    <Stack>
                      <TextField
                        name="ccEmail"
                        type="email"
                        variant="outlined"
                        size="small"
                        placeholder="Enter Your NHS Secure Email Address"
                        value={ccEmail}
                        onChange={handleccEmailChange}
                        error={ccErrorhadle?.type}
                      />
                      <Typography
                        color="error"
                        regular
                        variant="body2"
                        fontWeight={"200"}
                        fontSize={"12px !important"}
                      >
                        {ccErrorhadle?.message}
                      </Typography>
                    </Stack>
                  )}
                </Box>
              </Grid>

              {/* Preferred Ordergap * SLIDER */}
              <Grid>
                <Typography
                  color="#404040"
                  regular
                  variant="h3"
                  fontWeight={"600"}
                  marginTop={"30px"}
                  marginBottom={"8px !important"}
                  fontSize={"20px"}
                >
                  Order Buffer*
                  {/* <HtmlTooltipMain
                    title={`${"This means how long you like to order the prescriptions in advance. Repeatsmart will assist you by moving the orderdate slightly over time to build up your preferred Order Gap."}`}
                  >
                    <Info className={classes.infoIcon} />
                  </HtmlTooltipMain> */}
                </Typography>
                <Typography
                  color="black"
                  regular
                  variant="h5"
                  fontWeight={"400"}
                  fontSize={"18px !important"}
                >
                  Set how many days in advance to would like to order
                  prescriptions e.g. order script 10 days before medication is
                  delivered. This will help Repeatsmart to calculate the
                  suggested re-order dates.
                </Typography>
                <Typography
                  color="grey"
                  regular
                  variant="h6"
                  fontWeight={"400"}
                  fontSize={"14px !important"}
                >
                  This means how long you like to order the prescriptions in
                  advance. Repeatsmart will assist you by moving the orderdate
                  slightly over time to build up your preferred Order Gap.
                </Typography>
                <Grid display={"flex"} container>
                  <Slider
                    value={orderGap}
                    min={3}
                    max={28}
                    step={1}
                    onChange={handleSliderChange}
                    aria-labelledby="slider"
                    valueLabelDisplay="on"
                    className={classes.rsslider}
                    valueLabelFormat={valueLabelFormat}
                    marks={marks}
                    sx={{
                      // marginLeft:"30px",
                      "& .MuiSlider-markLabel": {
                        // color: "rgba(0, 0, 0, 0.6)",
                        color: "black",
                        marginLeft: "22px", // Change the color here
                        fontSize: "15px",
                      },
                      "& .MuiSlider-valueLabel": {
                        background: "#D9D9D9",
                        color: "black",
                        fontSize: "14px",
                      },
                    }}
                  />
                  {/* {OrderGapList?.map((item, index) => {
                    return (
                      <FormControlLabel
                        className={classes.labelWhiteSpaceNW}
                        value={item}
                        key={index}
                        checked={orderGap === item}
                        onChange={(e, value) => {
                          setOrderGap(item);
                        }}
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                            color="primary"
                          />
                        }
                        label={`${item} Days`}
                      />
                    );
                  })} */}
                </Grid>
              </Grid>
              {/* <>
               {loginUserDetail?.data?.data?.pharmacy_detail && (
                  <>
                    <Typography
                      color="secondary"
                      regular
                      variant="h4"
                      marginTop={"40px"}
                    >
                      CC emails to (pharmacy email address)
                   
                    </Typography>
                    <Box display={"flex"} className={classes.rsPharmacyMain}>
                      <TextField
                        variant="outlined"
                        placeholder="Pharmacy"
                        // label="Pharmacy"
                        size="small"
                        value={
                          loginUserDetail?.data?.data?.pharmacy_detail?.email
                            ? loginUserDetail?.data?.data?.pharmacy_detail
                                ?.email
                            : ""
                        }
                        id={`pharmacy`}
                        name={`pharmacy`}
                        onChange={(e, value) => {}}
                        className={classes.rsTextField}
                      />
                    </Box>
                  </>
                )}

                {emailPharmacy && (
                  <>
                    <Typography
                      color="secondary"
                      regular
                      variant="h4"
                      marginTop={"40px"}
                    >
                      CC emails to (pharmacy email address)
                     
                    </Typography>
                    <Box display={"flex"} className={classes.rsPharmacyMain}>
                      <TextField
                        variant="outlined"
                        placeholder="Pharmacy"
                        // label="Pharmacy"
                        size="small"
                        value={emailPharmacy}
                        id={`pharmacy`}
                        name={`pharmacy`}
                        onChange={(e, value) => {}}
                        className={classes.rsTextField}
                      />
                    </Box>
                  </>
                )}
                </> */}
              {loginUserDetail?.data?.data?.role === "user" && (
                <>
                  <Typography
                    color="#404040"
                    regular
                    variant="h3"
                    fontWeight={"600"}
                    marginTop={"30px"}
                    marginBottom={"8px !important"}
                    fontSize={"20px"}
                  >
                    Driver Filter *
                  </Typography>
                  <Typography
                    color="grey"
                    regular
                    variant="h6"
                    fontWeight={"400"}
                    fontSize={"14px !important"}
                  >
                    Only see the prescriptions which have been ordered after:
                  </Typography>
                  <Grid display={"flex"} container>
                    {afterOrderDateItems?.map((item, index) => {
                      return (
                        <FormControlLabel
                          className={clsx(
                            classes.labelWhiteSpaceNW,
                            classes.driverFilter
                          )}
                          value={item?.value}
                          key={index}
                          checked={orderItem === item?.value}
                          onChange={(e, value) => {
                            setOrderItem(item?.value);
                          }}
                          control={
                            <Checkbox
                              icon={<RadioButtonUncheckedIcon />}
                              checkedIcon={<RadioButtonCheckedIcon />}
                              color="primary"
                            />
                          }
                          label={`${item?.label}`}
                        />
                      );
                    })}
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.rssubmit}>
        <Button
          className="BtnGreen"
          // className={classes.rsSettingSaveBtn}
          variant="contained"
          onClick={() => updateSettingAction()}
        >
          Save
        </Button>
      </Grid>
      {/* {width < 560 && (
        <>
          <Grid
            container
            columnSpacing={2.5}
            rowSpacing={3}
            className={classes.rsPatientGridOne}
          >
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Paper
                elevation={0}
                className={
                  loginUserDetail?.data?.data?.role === "user"
                    ? classes.rsDSetting
                    : classes.rsOSetting
                }
                style={{
                  height:
                    loginUserDetail?.data?.data?.role === "user"
                      ? "1054px"
                      : "713px",
                }}
              >
                <Box className="GlobalSettingHeading">
                  <Typography variant="h3" medium color="secondary">
                    Global Setting
                  </Typography>
                  <Box>
                    <Button
                      className={classes.activityBtn}
                      variant="contained"
                      startIcon={
                        <PrimaryIcon
                          icon={ActivityLog}
                          color="white"
                          width="16px"
                          height="16px"
                        />
                      }
                      onClick={() => {
                        navigate(`/activity`);
                      }}
                    >
                      Activity Log
                    </Button>

                    {loginUserDetail?.data?.data?.role === "pharmacy" && (
                      <Button
                        className={classes.activityBtn}
                        variant="contained"
                        startIcon={
                          <PrimaryIcon
                            icon={CreditScoreIcon}
                            color="white"
                            width="16px"
                            height="16px"
                          />
                        }
                        onClick={() => {
                          navigate(`/payment-log`);
                        }}
                      >
                        Payment Log
                      </Button>
                    )}
                  </Box>
                </Box>
                <Divider />
                <Typography
                  regular
                  variant="h3"
                  fontWeight={"600"}
                  marginTop={"20px"}
                  color="black"
                >
                  Preferred Ordergap *
                  <HtmlTooltipMain
                    title={`${"This means how long you like to order the prescriptions in advance. Repeatsmart will assist you by moving the orderdate slightly over time to build up your preferred Order Gap."}`}
                  >
                    <Info className={classes.infoIcon} />
                  </HtmlTooltipMain>{" "}
                </Typography>
                <Box display={"flex"}>
                  <Slider
                    value={orderGap}
                    min={3}
                    max={28}
                    step={1}
                    onChange={handleSliderChange}
                    aria-labelledby="slider"
                    valueLabelDisplay="on"
                    className={classes.rsslider}
                    marks={marks}
                    sx={{
                      "& .MuiSlider-markLabel": {
                        color: "rgba(0, 0, 0, 0.6)",
                        marginLeft: "22px",
                      },
                    }}
                  />
                </Box>
                <Typography
                  regular
                  variant="h3"
                  fontWeight={"600"}
                  marginTop={"20px"}
                  color="black"
                >
                  Chase Up *
                  <HtmlTooltipMain
                    title={`${"Choose how long you would like to wait until users start to chase up prescriptions. After e.g. 48 hours the chase up icon will appear on waiting list."}`}
                    className={classes.rsTooltip}
                  >
                    <Info className={classes.infoIcon} />
                  </HtmlTooltipMain>{" "}
                </Typography>
                <Box display={"flex"}>
                  {chaseUpList?.map((item, index) => {
                    return (
                      <FormControlLabel
                        className={classes.rsDlabelWhiteSpaceNW}
                        value={item}
                        key={index}
                        checked={chaseUp === item}
                        onChange={(e, value) => {
                          setChaseUp(item);
                        }}
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                            color="primary"
                          />
                        }
                        label={`${item} Days`}
                      />
                    );
                  })}
                </Box>
                <Typography
                  regular
                  variant="h3"
                  fontWeight={"600"}
                  marginTop={"30px"}
                  color="black"
                  fon
                >
                  Archive *
                  <HtmlTooltipMain
                    title={`${"Auto archive order if not collected in X days."}`}
                    className={classes.rsTooltip}
                  >
                    <Info className={classes.infoIcon} />
                  </HtmlTooltipMain>{" "}
                </Typography>
                <Box display={"flex"}>
                  {archiveList?.map((item, index) => {
                    return (
                      <FormControlLabel
                        className={classes.rsDlabelWhiteSpaceNW}
                        value={item}
                        key={index}
                        checked={archive === item}
                        onChange={(e, value) => {
                          setArchive(item);
                        }}
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                            color="primary"
                          />
                        }
                        label={`${item} Days`}
                      />
                    );
                  })}
                </Box>
                <Typography
                  regular
                  variant="h3"
                  fontWeight={"600"}
                  marginTop={"20px"}
                  color="black"
                >
                  CC emailed order to pharmacy *
                </Typography>
                <Box display={"flex"}>
                  {ccList?.map((item, index) => {
                    return (
                      <FormControlLabel
                        className={classes.rsDlabelWhiteSpaceNW}
                        value={item}
                        key={index}
                        checked={ccMain === item}
                        onChange={(e, value) => {
                          setCCMain(item);
                        }}
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                            color="primary"
                          />
                        }
                        label={`${item}`}
                      />
                    );
                  })}
                </Box>
                {loginUserDetail?.data?.data?.role === "user" && (
                  <>
                    <Typography
                      regular
                      variant="h3"
                      fontWeight={"600"}
                      marginTop={"20px"}
                      color="black"
                    >
                      Driver Filter *
                    </Typography>
                    <Box className={classes.rsOrderDate}>
                      {" "}
                      Only see the prescriptions which have been ordered after:
                    </Box>
                    <Box display={"flex"}>
                      {afterOrderDateItems?.map((item, index) => {
                        return (
                          <FormControlLabel
                            className={classes.labelWhiteSpaceNW}
                            value={item?.value}
                            key={index}
                            checked={orderItem === item?.value}
                            onChange={(e, value) => {
                              setOrderItem(item?.value);
                            }}
                            control={
                              <Checkbox
                                icon={<RadioButtonUncheckedIcon />}
                                checkedIcon={<RadioButtonCheckedIcon />}
                                color="primary"
                              />
                            }
                            label={`${item?.label}`}
                          />
                        );
                      })}
                    </Box>
                  </>
                )}
              </Paper>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={classes.rsDsubmit}
          >
            <Button
              className="BtnGreen"
              variant="contained"
              onClick={() => updateSettingAction()}
            >
              Save
            </Button>
          </Grid>
        </>
      )} */}
      <AccessDialog open={accessopen} setOpen={setAccessopen} />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  globalSetting: state.order.globalSetting,
});

const mapDispatchToProps = (dispatch) => ({
  updateGlobalSettingAction: (payload, actionType) =>
    dispatch({ type: START_UPDATE_GLOBAL_SETTING, payload, actionType }),
  getGlobalSettingAction: () => dispatch({ type: START_GLOBAL_SETTING }),
  getCollectionRxAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_LIST, payload }),
  getCollectionCountAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_COUNT, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSettingMain);
